import React, { useEffect } from 'react';

const LinkedInCallback = () => {
    useEffect(() => {
        // Fonction pour extraire les paramètres de l'URL
        const getUrlParameter = (name) => {
            name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
            const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
            const results = regex.exec(window.location.search);
            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        };

        // Traitement au chargement de la page
        const code = getUrlParameter('code');
        const error = getUrlParameter('error');
        const errorDescription = getUrlParameter('error_description');

        if (error) {
            // Erreur d'authentification - rediriger vers la page principale avec l'erreur
            console.error('❌ Erreur LinkedIn:', errorDescription || error);
            window.location.href = `${window.location.origin}/generator?linkedin_error=${encodeURIComponent(errorDescription || 'Erreur lors de l\'authentification')}`;
        } else if (code) {
            // Succès - rediriger vers la page principale avec le code
            console.log('✅ Code d\'autorisation reçu:', code);
            setTimeout(() => {
                window.location.href = `${window.location.origin}/generator?code=${encodeURIComponent(code)}`;
            }, 1000);
        } else {
            // Aucun paramètre reçu - rediriger vers la page principale
            console.error('❌ Aucun paramètre reçu');
            window.location.href = `${window.location.origin}/generator?linkedin_error=${encodeURIComponent('Aucun paramètre reçu')}`;
        }

        // Fermer automatiquement après 3 secondes
        setTimeout(() => {
            try {
                if (window.opener) {
                    window.close();
                }
            } catch (error) {
                console.log('Fenêtre non fermable automatiquement');
            }
        }, 3000);
    }, []);

    return (
        <div style={{
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            margin: 0,
            padding: '20px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <div style={{
                background: 'white',
                padding: '40px',
                borderRadius: '16px',
                boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                textAlign: 'center',
                maxWidth: '400px',
                width: '100%'
            }}>
                <div style={{
                    width: '40px',
                    height: '40px',
                    border: '4px solid #f3f3f3',
                    borderTop: '4px solid #0077b5',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    margin: '0 auto 20px'
                }}></div>
                <h1 style={{ color: '#333', marginBottom: '10px' }}>
                    Connexion en cours...
                </h1>
                <p style={{ color: '#666', marginBottom: '20px' }}>
                    Nous traitons votre connexion LinkedIn
                </p>
                <style>{`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
            </div>
        </div>
    );
};

export default LinkedInCallback;
